import type { TextFieldProps } from "react-aria-components";

import React from "react";

import {
  ClearableInput,
  FieldError,
  Label,
  TextField,
} from "@/components/field";

interface BrandTextFieldProps extends Omit<TextFieldProps, "children"> {
  errorMessage?: string;
  label: string;
  onClear: () => void;
  placeholder?: string;
  requiredHint?: boolean;
  showClearButton: boolean;
}

export const BrandTextField = React.forwardRef<
  HTMLInputElement,
  BrandTextFieldProps
>(function BrandTextField(
  {
    errorMessage,
    label,
    onClear,
    placeholder,
    requiredHint,
    showClearButton,
    ...textFieldProps
  },
  ref,
) {
  return (
    <TextField className="flex-1" validationBehavior="aria" {...textFieldProps}>
      <Label requiredHint={requiredHint}>{label}</Label>
      <ClearableInput
        onClear={onClear}
        placeholder={placeholder}
        ref={ref}
        showClearButton={showClearButton}
      />
      <FieldError>{errorMessage}</FieldError>
    </TextField>
  );
});
